const defaultSearchResultLength = 25;
const stringDelimeter = "|d.e.l.i.m.e.t.e.r|";
export { defaultSearchResultLength, stringDelimeter };
